import { useEffect, useRef, useState } from "react";
import { MapPin, LoaderCircle } from "lucide-react";
import { api, errorText } from "../../lib/api";

export const AreaPicker = ({ value, onChange, id = "checkout-area" }) => {
  const [query, setQuery] = useState(value?.name || ""), [options, setOptions] = useState([]), [busy, setBusy] = useState(false), [error, setError] = useState(""), [open, setOpen] = useState(false);
  const timer = useRef(null);
  useEffect(() => {
    if (query.trim().length < 3 || query === value?.name) { setOptions([]); return; }
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      setBusy(true); setError("");
      try { setOptions((await api.get("/shipping/areas", {params: {q: query.trim()}})).data.areas); setOpen(true); }
      catch (err) { setError(errorText(err)); }
      finally { setBusy(false); }
    }, 400);
    return () => clearTimeout(timer.current);
  }, [query, value]);
  const pick = area => { onChange(area); setQuery(area.name); setOptions([]); setOpen(false); };
  return <div className="area-picker" data-testid={`${id}-picker`}>
    <label className="field" htmlFor={id}><span>Kecamatan / kode pos tujuan</span>
      <div className="area-input"><MapPin size={16}/><input id={id} data-testid={id} value={query} autoComplete="off" placeholder="Ketik nama kecamatan atau kode pos…" onChange={e => { setQuery(e.target.value); if (value) onChange(null); }} onFocus={() => options.length && setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)}/>{busy && <LoaderCircle size={16} className="spin"/>}</div>
    </label>
    {open && options.length > 0 && <ul className="area-options" role="listbox" data-testid={`${id}-options`}>{options.map(a => <li key={a.id}><button type="button" role="option" aria-selected={value?.id === a.id} data-testid={`${id}-option-${a.id}`} onMouseDown={() => pick(a)}>{a.name}</button></li>)}</ul>}
    {value && <p className="area-selected" data-testid={`${id}-selected`}><MapPin size={13}/> {value.name}</p>}
    {error && <p className="form-error" role="alert" data-testid={`${id}-error`}>{error}</p>}
  </div>;
};
